module.exports = __webpack_public_path__ + "img/top-border-sb.11b31a54.png";